import { ILocation } from 'interfaces';

export type DiscountRequestDTO = {
  categoryId: number;
  companyName: string;
  companyContacts: string;
  locationId: number;
  hrId: number;
  comment?: string;
};

export enum DiscountRequestStatus {
  NONE = 'NONE',
  NEW = 'NEW',
  IN_PROGRESS = 'IN_PROGRESS',
  DECLINED = 'DECLINED',
  APPROVED = 'APPROVED',
}

export type DiscountRequestData = {
  id: number;
  firstName?: string;
  lastName?: string;
  login: string;
  categoryName: string;
  companyName?: string;
  companyContacts?: string;
  comment: string;
  createdDate: string;
  status: DiscountRequestStatus;
  locationDto: ILocation;
  hrId?: number;
};

export type IDiscountRequest = {
  content: DiscountRequestData[];
  empty: boolean;
  first: boolean;
  last: boolean;
  numberOfElements: number;
  totalElements: number;
  totalPages: number;
  size: number;
};

export type discountRequestResponseParams = Omit<IDiscountRequest, 'content'>;

export type IDiscountRequestHistoryParams = {
  page?: number;
  size?: number;
  sort: string[];
};

export enum DiscountRequestHistoryItemType {
  STATUS_CHANGED = 'STATUS_CHANGED',
  HR_CHANGED = 'HR_CHANGED',
}

export type DiscountRequestHistoryItem = {
  id: number;
  demandId: number;
  eventType: DiscountRequestHistoryItemType;
  statusBefore: DiscountRequestStatus;
  statusAfter: DiscountRequestStatus;
  date: string;
  userLogin: string;
  comment?: string;
  responsibleHr?: string;
};

export type IAssignDiscountRequestHrParams = {
  demand: number;
  hr: number;
};

export type ISetDiscountRequestStatusParams = {
  discountId: number;
  status: DiscountRequestStatus;
  comment?: string;
};

export enum DiscountRequestAssignmentType {
  ALL = 'ALL',
  UNASSIGNED = 'UNASSIGNED',
  ASSIGNED_TO_ME = 'ASSIGNED_TO_ME',
}

export enum DiscountRequestDirectionType {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum DiscountRequestSortBy {
  CREATED_DATE = 'CREATED_DATE',
  STATUS = 'STATUS',
}

export type DiscountRequestListHrParams = {
  assignment: DiscountRequestAssignmentType;
  direction: DiscountRequestDirectionType;
  statuses: DiscountRequestStatus[];
  locationId?: number;
  countryId?: number;

  page?: number;
  countries: string[];
  size: number;
  sortBy: DiscountRequestSortBy;
};

export type DiscountRequestListUserParams = {
  userId: number;
  page: number;
  size: number;
  sort?: string[];
};
